import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { COMPARISON_ROWS } from '../../data/content';
export function Comparison() {
  return <section className="w-full bg-carbon-2" aria-labelledby="comparison-heading" data-id="element-54">
      <SectionReveal className="mx-auto max-w-4xl px-5 py-16 sm:py-20" data-id="element-55">
        <h2 id="comparison-heading" className="mb-10 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-56">
          ⏰ ¿Cuánto te cuesta NO tenerlo?
        </h2>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-57">
          {/* Sin Megapack */}
          <div className="rounded-lg border border-red-900/60 bg-red-950/30 p-5" data-id="element-58">
            <h3 className="mb-4 text-center font-heading text-lg font-bold uppercase text-red-400" data-id="element-59">
              Sin Megapack
            </h3>
            <ul className="space-y-3" data-id="element-60">
              {COMPARISON_ROWS.map(row => <li key={row.without} className="flex items-start gap-2 text-sm text-muted" data-id="element-61">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-red-500" data-id="element-62" />
                  {row.without}
                </li>)}
            </ul>
          </div>

          {/* Con Megapack */}
          <div className="rounded-lg border border-emerald/40 bg-emerald/10 p-5" data-id="element-63">
            <h3 className="mb-4 text-center font-heading text-lg font-bold uppercase text-emerald" data-id="element-64">
              Con Megapack
            </h3>
            <ul className="space-y-3" data-id="element-65">
              {COMPARISON_ROWS.map(row => <li key={row.with} className="flex items-start gap-2 text-sm text-soft" data-id="element-66">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-emerald" data-id="element-67" />
                  {row.with}
                </li>)}
            </ul>
          </div>
        </div>
      </SectionReveal>
    </section>;
}